export const CART_VALIDATION_ERROR_CODE = 60;
export const SYSTEM_DATABASE_VALIDATION_ERROR_CODE = 61;
export const MAX_CART_ITEM_COUNT = 70;
export const MAX_CART_ITEM_SUM = 71;
export const validationErrorCodes = [
	CART_VALIDATION_ERROR_CODE,
	SYSTEM_DATABASE_VALIDATION_ERROR_CODE,
	MAX_CART_ITEM_COUNT,
	MAX_CART_ITEM_SUM,
];
